import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ExaminationSlide, ExaminationSlideList } from '../model/examinationSlides.model';
import { AuthenticationService } from './authentification.service';

@Injectable()
export class ExaminationSlidesService extends KiwixiService {

    apiExaminationSlides = environment.server + 'examinations_slides/';

    extractIdFromUrl(url) {
        if (url) {
            return parseInt(url.split('/')[url.split('/').length - 2], 0);
        }
        return null;
    }

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private authentificationService: AuthenticationService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getExaminationsSlides(params: HttpParams): Observable<ExaminationSlideList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSlideList>(this.apiExaminationSlides + '?salt=' + Math.random(), {
            headers: header,
            params: params
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationSlideList>(`getObservableExaminationsSlides`))
            );
    }

    getExaminationsSlidesById(id: string): Observable<ExaminationSlide> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSlide>(this.apiExaminationSlides + id + '/' + '?salt=' + Math.random(), {
            headers: header,
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationSlide>(`getObservableExaminationsVariants`))
            );
    }

    postExaminationSlides(params): Observable<ExaminationSlide> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<ExaminationSlide>(this.apiExaminationSlides, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlide>(`Création d'une slide`)),
            );
    }

    patchExaminationSlide(url: string, params) {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<ExaminationSlide>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlide>(`Update d'une slide`)),
            );
    }
    deleteExaminationSlide(id): Observable<ExaminationSlide> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete<ExaminationSlide>(this.apiExaminationSlides + id + '/', {
            headers: header,
        })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlide>(`delete ExaminationSlide`))
            );
    }
}
